export default "__VITE_ASSET__5566644a__"